import { getProblemById, getFileSuffixByLanguageID} from "../Data/ProblemsMethod";

export default async function FetchMainCode(ProblemID, LanguageID){
    const currProblem = getProblemById(ProblemID)
    const pathToCodeFolder = currProblem.path_to_code_folder;
    const FileNameLessLanguageSuffix = currProblem.problem_name.split(' ').join('') + "Main"; // As a rule, main code file name must match problem name + "Main"
    const fileSuffix = getFileSuffixByLanguageID(LanguageID);
    const mainCodeFileName = FileNameLessLanguageSuffix + fileSuffix;
    const pathToMainCode = pathToCodeFolder + mainCodeFileName;
    const mainCodeFetch = await fetch(pathToMainCode);
    const mainCode = await mainCodeFetch.text();
    return mainCode;
}